
import { Component, OnInit, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { ScreenComponent } from '@core/features/screen.component';
import * as fromMaster from '@features/master/consulta-clientes/store';
import { orderBy } from 'lodash';


import { HttpClient } from '@angular/common/http';
import { FeatureService } from '@services/feature/feature.service';
import { MasterVisualizarClienteComponent } from './../visualizar-cliente/master-visualizar-cliente.component';

import { environment } from '@env/environment';
const BASE_PATH = environment.basePath;
/**
* This Component manages the presentation logic of Edit screen
*
*/
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog, MatDialogConfig, MatDialogRef } from "@angular/material/dialog";
import { MasterConsultaClientesService } from './master-consulta-clientes.service';
import { compare } from '@app/features/utils/compare-string';

@Component({
  selector: 'app-master-consulta-clientes',
  templateUrl: './master-consulta-clientes.component.html'
})
export class MasterConsultaClientesComponent implements OnInit {
  @ViewChild('input', { static: false }) searchInput: ElementRef;
  displayedColumns: string[] = ['nome', 'usuarios', 'fundos', 'actions'];
  dataSource: any;
  clientes: any;
  clientStatus = false;
  filterValue = '';
  sorted: boolean = true;
  clientsComplete: any;
  clientsFilter: any;
  fundsSorted: boolean = false;

  constructor(
    private _masterClientesService: MasterConsultaClientesService,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.getClientesStatus();
  }

  getClientesStatus() {
    this._masterClientesService.getClientesStatus(!this.clientStatus).then((response) => this.dataSource = new MatTableDataSource(response)).then(() => {
      this.dataSource.data = orderBy(this.dataSource.data, 'legalName', 'asc');
      this.dataSource.filterPredicate = (data, filter) => {
        if (data.legalName === null || data.legalName === undefined) {
          data.legalName = '';
        }
        return (
          data.legalName.toLowerCase().includes(filter.toLowerCase())
        );
      };
    });
  }

  getClientesSearch(value) {
    this._masterClientesService.getClientesSearch(value, !this.clientStatus).then((response) => this.dataSource = new MatTableDataSource(response)).then(() => {
      this.dataSource.filterPredicate = (data, filter) => {
        if (data.legalName === null || data.legalName === undefined) {
          data.legalName = '';
        }
        return (
          data.legalName.toLowerCase().includes(filter.toLowerCase())
        );
      };
    });

  }

  toggleStatus() {
    this.clientStatus = !this.clientStatus;
    this.getClientesStatus();
    this.searchInput.nativeElement.value = '';
    this.clientsComplete = [];
  }

  openDialog(id) {

    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.height = '90vh';
    dialogConfig.width = '92vw';
    dialogConfig.maxWidth = '100vw';
    dialogConfig.position = {
      'top': '83px'
    }

    let dialogRef = this.dialog.open(MasterVisualizarClienteComponent, dialogConfig);
    dialogRef.componentInstance.id = id;
  }

  orderColumn(column: string) {
    this.fundsSorted = !this.fundsSorted;

    if (this.fundsSorted) {
      this.dataSource.data = this.dataSource.data.naturalSort([column]);
    } else {
      this.dataSource.data = this.dataSource.data.naturalSort([column]).reverse();
    }
  }

  applyFilter(event: Event) {
    this.clientsFilter = (event.target as HTMLInputElement).value;
    this.dataSource.filter = this.clientsFilter.trim().toLowerCase();

    if (this.clientsFilter.length > 0 && this.clientsFilter.length % 2 == 0) {
      this.clientsComplete = this.dataSource.filteredData
    } else if (this.clientsFilter.length == 0) {
      this.clientsComplete = []
    }
  }
}
